import React from "react"
import NutritionCalculatorWrapperStyle from "./NutritionCalculatorWrapperStyle.module.styl"

const NutritionCalculatorWrapper = ({ children }) => {
  return (
    <div id="calculator" className={NutritionCalculatorWrapperStyle.wrapper}>
      <p className={NutritionCalculatorWrapperStyle.text}>
        Този хранителен навигатор ползва хранителната база данни към
        Министерството на земеделието на САЩ
        <a
          href="https://fdc.nal.usda.gov/fdc-app.html#/food-details/558171/nutrients"
          target="_blank"
          rel="noreferrer"
        >
          - прочетете
        </a>
        . Когато търсите храни е необходимо да търсите с английски названия на
        желаната храна.
      </p>
      {children}
    </div>
  )
}

export default NutritionCalculatorWrapper
